import { render } from "./googleAutocomplete.vue?vue&type=template&id=bd51c0f8&ts=true"
import script from "./googleAutocomplete.vue?vue&type=script&lang=ts"
export * from "./googleAutocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__